import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { HomeApi, HomeApiImpl } from './apis/home-api';
import { HomeRdApi, HomeRdApiImpl } from './apis/home-rd-api';
import { HomeMaterialApi, HomeMaterialApiImpl } from './apis/home-material-api';
import { HomeIpApi, HomeIpApiImpl } from './apis/home-ip-api';
import { HomeLsApi, HomeLsApiImpl } from './apis/home-ls-api';
import { HomeService } from './services/home-service';
import { HomeServiceImpl } from './services/impls/home-service';

export const homeContainer = new ContainerModule((bind) => {
    bind(HomeRdApi).to(HomeRdApiImpl);
    bind(HomeApi).to(HomeApiImpl);
    bind(HomeMaterialApi).to(HomeMaterialApiImpl)
    bind(HomeIpApi).to(HomeIpApiImpl);
    bind(HomeLsApi).to(HomeLsApiImpl);
    bind(HomeService).to(HomeServiceImpl);
});
